import { ReactElement } from 'react';

import { TherapeuticGroupStatus } from '@dreryk/egabinet-group-session-frontend-api';

import { Message } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

import { useOptions } from './StatusCell.hooks';

type StatusCellProps = {
   readonly status: TherapeuticGroupStatus;
};

export const StatusCell = (props: StatusCellProps): ReactElement => {
   const options = useOptions();

   return (
      <Message
         displayIndicator
         type={props.status}
         options={options}
         label={translationKeys.groupSessionsStatusMap[props.status]}
         testId={'waitlistEntryStatus'}
      />
   );
};
